// Утилиты для валидации данных форм

/**
 * Валидация формы лида
 * @param {Object} form - объект формы
 * @returns {Object} - { ok: boolean, msg?: string }
 */
export function validateLeadForm(form) {
  if (!form.name?.trim()) {
    return { ok: false, msg: "Укажи имя" };
  }
  
  if (!form.contact?.trim()) {
    return { ok: false, msg: "Добавь контакт" };
  }
  
  return { ok: true };
}

/**
 * Поиск дубликата по контакту
 * @param {Array} leads - массив лидов
 * @param {string} contact - контакт для проверки
 * @param {string|null} excludeId - ID для исключения из проверки
 * @returns {Object|undefined} - найденный дубликат или undefined
 */
export function findDuplicateByContact(leads, contact, excludeId = null) {
  const norm = contact.trim().toLowerCase();
  return leads.find((l) => l.contact.trim().toLowerCase() === norm && l.id !== excludeId);
}

/**
 * Валидация email
 * @param {string} email
 * @returns {boolean}
 */
export function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * Валидация Telegram username
 * @param {string} username
 * @returns {boolean}
 */
export function isValidTelegramUsername(username) {
  return username.startsWith("@") && username.length > 1;
}

/**
 * Валидация количества фото
 * @param {Array} photos
 * @param {number} maxPhotos
 * @returns {Object} - { ok: boolean, msg?: string }
 */
export function validatePhotosCount(photos, maxPhotos = 3) {
  if (!Array.isArray(photos)) {
    return { ok: true };
  }
  
  if (photos.length > maxPhotos) {
    return { ok: false, msg: `Максимум ${maxPhotos} фото` };
  }
  
  return { ok: true };
}
